import { formatDate, KeyValue } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {  Router } from '@angular/router';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { TooltipConfig } from 'ngx-bootstrap/tooltip';
import { SubSink } from 'subsink';
import { ApiHandlerService } from '../../../../core/api-handlers';
import { SwalService } from '../../../../core/services/swal.service';
import { UtilityService } from '../../../../core/services/utility.service';
import { FlightService } from '../../flight.service';
import { AppGlobal } from 'projects/b2c/src/app/app.global';

export function getAlertConfig(): TooltipConfig {
    return Object.assign(new TooltipConfig(), {
        placement: 'right',
        container: 'body',
    });
}

@Component({
    selector: 'app-guest-details',
    templateUrl: './guest-details.component.html',
    styleUrls: ['./guest-details.component.scss'],
    providers: [{ provide: TooltipConfig, useFactory: getAlertConfig }],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GuestDetailsComponent implements OnInit, OnDestroy {
    @ViewChild('optionRef', { static: false }) optionRef: ElementRef;
    appRef: any;
    terms: boolean = false;
    phoneCodes: Array<any> = [];
    primaryColour: any;
    secondaryColour: any;
    loadingTemplate: any;
    bsDateConf = {
        isAnimated: true,
        dateInputFormat: 'DD-MM-YYYY',
        containerClass: 'theme-blue',
        showWeekNumbers: false
    };

    isCollapsed = true;
    isCollapsedFareSumm = true;
    isCollapsedGst = true;
    isCollapsedServiceReqs = true;
    flight: any;
    flightString: any;
    traveller: any = false;
    travellerString: any;
    contactForm: FormGroup;
    usaDetailsForm: FormGroup;
    titles: any = [];
    infantsTitles: any = [];
    countries: any = [];
    loading: boolean;
    submitted: boolean = false;
    selectedTitle;
    html = `<div class="container">
  <div class="row py-3">
      <div class="col-12 font-weight-bold">
          Information on Entry of Name(s)
      </div>
      <div class="col-12 mt-2">
          Name of the <mark>Passenger(s)</mark> must be identical with the name displayed on the selected ID type.
      </div>
      <div class="col-12">
          <div class="row col-12 bg my-2 mx-0 p-3">
              <div class="col-12 mb-3"> <span class="font-weight-bold f-14"> Passport </span> </div>
              <div class="col-3 pt-4">
                  <i class=" fa fa-5x fa-users"></i>
              </div>
              <div class="col-9">
                  <div class="d-flex flex-column">
                      <div class="text-muted">
                          <small> Last name </small> 
                      </div>
                      <div class="text-dark">
                          <span>
                              JONH
                          </span>
                      </div>
                      <div class="text-muted mt-3">
                          <small> First & middle name </small> 
                      </div>
                      <div class="text-dark">
                          <span>
                          STEVE  DOE
                          </span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="col-12 mt-3 f-12">
          <span class="font-italic f-14"> 
              N.B.- 
          </span>
          Passenger(s) who don't have first names may enter their last name in the boxese for both "last name" and "first & middle names".
      </div>
  </div>
</div>`;

    isConfirmed = false;
    maxDate = new Date();
    maxDateAdult: any;
    minDateAdult: any;
    maxDateChild: any;
    minDateChild: any;
    maxDateInfant: any;
    minDateInfant: any;
    extraServices = false;
    isUpdatePassengers = false;
    currentUser: any;
    flightType: any;
    protected subs = new SubSink();
    travelList: any = [];
    seatMapData:any;
    seatMapSectors:any;
    selectedPassengerIndex:any;
    selectedPassenger:any;
    selectedTabIndex: number = 0;
    keysArray = [];
    isSeatLoading:boolean=true;
    showSeatSelection:boolean=false;

    txtCouponCodeValue: string = ''; // Variable to hold the input value
    disableApplyPromo: boolean = false;
    promocodeList: any = [];
    selectedPromocode = '';
    promocode: any;
    isInvalidPromo: boolean = false;
    originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
        return 0;
    }

    reverseKeyOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
        return a.key > b.key ? -1 : (b.key > a.key ? 1 : 0);
    }

    valueOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
        return a.value.localeCompare(b.value);
    }
    constructor(
        private fb: FormBuilder,
        private router: Router,
        private apiHandlerService: ApiHandlerService,
        private flightService: FlightService,
        private utility: UtilityService,
        private cdRef: ChangeDetectorRef,
        private swalService: SwalService,
        private renderer: Renderer2,
        private appGlobal: AppGlobal,
    ) { }
    airline_logo: string = '';
    ngOnInit() {
        this.currentUser = JSON.parse(sessionStorage.getItem('b2cUser'));
        if (this.currentUser) {
            this.getTravellersList();
        }
        this.getPhoneCodeList();
        this.getCountryList();
        this.getTitleList();
        this.getPromoCodeList();
        this.airline_logo = this.flightService.airline_logo;
        this.subs.sink = this.flightService.flightType.subscribe(res => this.flightType = res)
        this.subs.sink = this.flightService.extraServices.subscribe(res => {
            if (res) {
                this.extraServices = true;
            } else {
                this.extraServices = false;
            }
        });
        this.flightService.editPassenger.subscribe(data => {
            if (data && data == true) {
                this.isUpdatePassengers = true;
            }
        })

        this.flightService.countryList.subscribe(() => {
            // this.countries = res;
        });
        this.createContactForm();
        this.subs.sink = this.flightService.loading.subscribe(res => {
            this.loading = res;
        });
        this.subs.sink = this.flightService.bookingFlightData.subscribe(res => {
            if (typeof res == 'object' && res.JourneyList.hasOwnProperty('FlightDetails')) {
                this.flightService.extraFees.next(this.flightService.extraFees.value);
                this.traveller = this.flightService.traveller;
                if ((res.JourneyList.booking_source == 'ZBAPINO00002' || res.JourneyList.booking_source == 'ZBAPINO00007') && this.currentUser && this.currentUser.id == 44) {
                    this.showSeatSelection = true;
                    this.getSeatLayout(res.JourneyList);
                }
                this.flight = res.JourneyList;
                this.passengers.clear();
                let leadPax = 1;
                for (let t of Object.keys(this.traveller)) {
                    if (this.traveller[t]) {
                        for (let i = 0; i < this.traveller[t]; i++) {
                            this.addPassenger(t, i, leadPax);
                            leadPax = 0;
                        }
                    }
                }
            } else {
                this.router.navigate(['/']);
            }
            this.cdRef.detectChanges();
        });

        this.maxDateAdult = this.addYearsToDate(-12, 0);
        this.minDateAdult = this.addYearsToDate(-100, 0);
        this.maxDateChild = this.addYearsToDate(-2, 0);
        this.minDateChild = this.addYearsToDate(-12, 0);
        this.maxDateInfant = new Date();
        this.minDateInfant = this.addYearsToDate(-2,0);
        //this.getPassengerDetails(); // Commented to clear previously entered data
    }

    onTerms(e) {
        this.terms = e
    }

    getPassengerDetails() {
        this.flightService.passengerDetails.subscribe((data) => {
            if (data.length > 0) {
                this.patchValuesExt(data[1].contact);
                this.patchPassengers(data[1].passengers);
            }
        })
    }

    getPhoneCodeList() {
        this.subs.sink = this.apiHandlerService.apiHandler('phoneCodeList', 'POST')
            .subscribe(res => {
                if (res && res.data.length) {
                    this.phoneCodes = res.data;
                    this.cdRef.detectChanges();
                }
            });
    }

    getTitleList() {
        this.subs.sink = this.apiHandlerService.apiHandler('userTitlelist', 'POST')
            .subscribe(res => {
                if (res) {
                    this.titles = res.data;
                    this.infantsTitles = res.data.filter(t => t.titleId == 3 || t.titleId == 4);
                    this.cdRef.detectChanges();
                }
            });
    }

    getCountryList() {
        this.subs.sink = this.apiHandlerService.apiHandler('countryList', 'POST')
            .subscribe(res => {
                if (res && res.data.countries.length) {
                    this.flightService.countryList.next(res.data.countries)
                    this.countries = res.data.countries;
                    this.cdRef.detectChanges();

                }
            });
    }

    createContactForm() {
        this.contactForm = this.fb.group({
            passengers: this.fb.array([]),
            contact: this.fb.group({
                Title: [''],
                FirstName: ['',[Validators.required, Validators.maxLength(30), Validators.minLength(1), Validators.pattern(this.utility.regExp.fullName)]],
                MiddleName: [''],
                LastName: ['', [Validators.required, Validators.maxLength(30), Validators.minLength(1), Validators.pattern(this.utility.regExp.fullName)]],
                countryCode: ['+1', [Validators.required]],
                phoneAreaCode: '',
                phoneExtensionCode: '',
                phoneNumber: ['',  [Validators.required, Validators.pattern('^[0-9]+$')]],
                email: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(100), Validators.pattern(this.utility.regExp.email)]],
                message: ['']
            }),
            usaForm: [0],
            usaDetailsForm: this.fb.group({
                country_name: ['USA'],
                gender: ['Male'],
                types: ['resident'],
                address: [''],
                city: [''],
                state: [''],
                postal_code: ['']
            }),
            baggageProtection: [false]
        });
    }

    patchValuesExt(patchData) {
        this.contactForm.get('contact').patchValue({
            FirstName: patchData.FirstName,
            MiddleName: patchData.MiddleName,
            LastName: patchData.LastName,
            countryCode: patchData.countryCode,
            phoneAreaCode: patchData.phoneAreaCode,
            phoneExtensionCode: patchData.phoneExtensionCode,
            phoneNumber: patchData.phoneNumber,
            email: patchData.email
        });
        this.cdRef.detectChanges();
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;

    }

    createUsaDetailsForm() {
        this.usaDetailsForm = this.fb.group({
            // passengers: this.fb.array([]),
            // contact: this.fb.group({
            //     countryCode: ['+91', [Validators.required]],
            //     phoneAreaCode: '080',
            //     phoneExtensionCode: '91',
            //     phoneNumber: [123456789, [Validators.required]],
            //     email: ['', [Validators.required, Validators.email]],
            //     message: ['', [Validators.required]]
            // })
        });
    }

    patchPassengers(adults) {
        this.passengers.patchValue(adults);
        this.cdRef.detectChanges();
    }


    get passengers() {
        return this.contactForm.get('passengers') as FormArray;
    }

    addPassenger(tt: string, i: number, lead = 0) {
        this.passengers.push(this.createPassenger(tt, i, lead));
    }

    createPassenger(tt: string, i: number, lead = 0): FormGroup {
        const title = tt == 'infants' ? 'Miss' : 'Mr';
        const paxType = tt == 'adults' ? 1 : (tt == 'infants' ? 3 : 2);
        const bookingFlightData = this.flightService.bookingFlightData.getValue();
        let dateOfBirth:any;
        if (paxType == 2) {
            dateOfBirth = this.setChildDateOfBirth(bookingFlightData,i);
        }
        if (paxType == 3) {
            dateOfBirth = this.setInfantDateOfBirth(bookingFlightData,i);
        }
        return this.fb.group(
            {
                IsLeadPax: lead,
                Title: ['', [Validators.required]],
                FirstName: ['', [Validators.required, Validators.maxLength(30), Validators.minLength(1), Validators.pattern(this.utility.regExp.fullName)]],
                MiddleName: [''],
                LastName: ['', [Validators.required, Validators.maxLength(30), Validators.minLength(1), Validators.pattern(this.utility.regExp.fullName)]],
                PaxType: paxType,
                Gender: ['', [Validators.required]],
                DateOfBirth: [dateOfBirth, [Validators.required]],
                PassportNumber: this.flightType == 'International' ? ['', [Validators.required]] : [''],
                PassportExpiryDate: this.flightType == 'International' ? ['', [Validators.required]] : [''],
                PassportIssuingCountry: ['USA',],
                Nationality: ['USA',],
                CountryCode: '',
                CountryName: '',
                ContactNo: '',
                PhoneAreaCode: '',
                PhoneExtensionCode: '',
                City: '',
                PinCode: '',
                AddressLine1: '',
                AddressLine2: '',
                Email: '',
                travellerType: tt,
                travellerTypeCount: i + 1,
                BaggageId: [],
                MealId: [],
                SeatId: [],
                SelectedSeats: [],
                SelectedSelectorId:0,
                PassengerSelection:''// Used for passenger selection
            }
        );
    }


    onUpdatePassenges(phonecode: any) {
        phonecode = phonecode.split(/[()]/)[1];
        const result = this.phoneCodes.find(c => c.phone_code == phonecode);
        this.passengers.value.forEach((e, i) => {
            this.contactForm.controls['passengers']['controls'][i].patchValue({
                CountryCode: result.phone_code,
                CountryName: result.name
            });
        });
    }

    hasError = (controlName: string, errorName: string, arrayControl?: string, i?: number) => {
        if (typeof arrayControl !== 'undefined') {
            let formArrayName = this.contactForm.get(arrayControl) as FormArray;
            if (formArrayName && formArrayName != null)
                return ((this.submitted || formArrayName.controls[i]['controls'][controlName].touched) && formArrayName.controls[i]['controls'][controlName].hasError(errorName));
        } else {
            return ((this.submitted || this.contactForm.controls[controlName].touched) && this.contactForm.controls[controlName].hasError(errorName));
        }
    }

    hasContactError = (controlName: string, errorName: string, arrayControl?: string) => {
        if (typeof arrayControl !== 'undefined') {
            let formArrayName = this.contactForm.get(arrayControl) as FormArray;
            if (formArrayName && formArrayName != null)
                return ((this.submitted || formArrayName.controls[controlName].touched) && formArrayName.controls[controlName].hasError(errorName));
        }
    }

    onSubmitBooking() {
        this.submitted = true;
        if (!this.terms) {
            return;
        }
        if (!this.contactForm.valid) {
            return;
        }
        if (this.isUpdatePassengers == true) {
            this.editPassengers();
        } else {
            this.processCommitBooking();
        }
    }

    editPassengers() {
        this.flightService.loading.next(false);
        if (this.flight['Attr']['is_usa']) {
            this.contactForm.patchValue({ usaForm: 0 });
        } else {
            this.contactForm.patchValue({ usaForm: 1 });
        }
        const passengers = this.passengers.value;
        this.setSeatId(passengers);
        this.setNull(passengers);
        const cEmail = this.contactForm.get('contact.email').value;
        const cPhoneAreaCode = this.contactForm.get('contact.phoneAreaCode').value;
        const cPhoneExtensionCode = this.contactForm.get('contact.phoneExtensionCode').value;
        const cphoneNumber = this.contactForm.get('contact.phoneNumber').value;
        const passportCountryName = this.contactForm.get('contact.countryCode').value;

        const passengersTemp = passengers.map(p => {
            const DateOfBirth = "1994-01-01";
            const PassportExpiryDate = "2023-01-01";
            const Email = cEmail;
            const PhoneAreaCode = cPhoneAreaCode;
            const PhoneExtensionCode = cPhoneExtensionCode;
            const ContactNo = cphoneNumber;
            const CountryName = passportCountryName;
            let usaFormDetail = {};
            if (this.flight['Attr']['is_usa']) {
                Object.assign(usaFormDetail, {
                    City: this.contactForm.get('usaDetailsForm.city').value,
                    State: this.contactForm.get('usaDetailsForm.state').value,
                    CountryName: this.contactForm.get('usaDetailsForm.country_name').value,
                    CountryCode: 'USA',
                    AddressLine1: this.contactForm.get('usaDetailsForm.address').value,
                    AddressLine2: '.',
                    PinCode: this.contactForm.get('usaDetailsForm.postal_code').value,
                    Gender: this.contactForm.get('usaDetailsForm.Gender').value,
                    LocationType: this.contactForm.get('usaDetailsForm.types').value
                });

            }
            p.CountryCode = p.Nationality;
            return { ...p, DateOfBirth, PassportExpiryDate, ...usaFormDetail };
        });

        const created_by_id = this.utility.readStorage('b2cUser', sessionStorage)['id'];
        let commitBookingBody = {
            UserId: created_by_id,
            AppReference: this.appRef,
            booking_source: this.flight.booking_source,
            BookingSource: "B2C",
            // AppReference: this.flightService.resultToken,
            SequenceNumber: 0,
            ResultToken: this.flightService.resultToken,
            Passengers: passengersTemp,
            PromoCode: this.selectedPromocode,   
        }
        this.flightService.passengerDetails.next([commitBookingBody, this.contactForm.value]);

        this.subs.sink = this.apiHandlerService.apiHandler('updatePassengerDetails', 'POST', '', '', {
            AppReference: this.appRef,
            booking_source: this.flight.booking_source,
            passengerData: passengersTemp
        })
            .subscribe(res => {
                if (res.Status) {
                    this.router.navigate(['/flight/confirm-passenger']);
                } else {
                    this.swalService.alert.oops(res.Message);
                    setTimeout(() => {
                        this.router.navigate(['/flight/result']);
                    }, 100);
                }
                this.flightService.loading.next(false);
            })

    }

    processCommitBooking() {
        if (this.flight['Attr']['is_usa']) {
            this.contactForm.patchValue({ usaForm: 0 });
        } else {
            this.contactForm.patchValue({ usaForm: 1 });
        }
        const passengers = this.passengers.value;
        this.setSeatId(passengers);
        // this.setBaggageId(passengers);
        // this.setMealId(passengers);
        const cEmail = this.contactForm.get('contact.email').value;
        const cPhoneCode = this.contactForm.get('contact.countryCode').value;
        const cphoneNumber = this.contactForm.get('contact.phoneNumber').value;
        const passengersTemp = passengers.map((p, i) => {
            const DateOfBirth = p.DateOfBirth ? formatDate(p.DateOfBirth, 'yyyy-MM-dd',  'en-US') : '';
         
            if (p.PassportNumber == '' && (this.flight.booking_source != 'ZBAPINO00009' && this.flight.booking_source != 'ZBAPINO00008')) {
                p.PassportNumber = "BP012543" + i + (i + 1);
            }
            if (p.PassportExpiryDate == '') {
                p.PassportExpiryDate = formatDate(this.addYearsToDate(+5, +0), 'yyyy-MM-dd', 'en-US');
            } else {
                p.PassportExpiryDate = p.PassportExpiryDate ? formatDate(p.PassportExpiryDate, 'yyyy-MM-dd', 'en-US') : '';
            }
            const PassportExpiryDate = p.PassportExpiryDate;
            p.Email = cEmail;
            p.PhoneCode = cPhoneCode.includes('(') ? cPhoneCode.split(/[()]/)[1] : cPhoneCode;
            p.phoneAreaCode = cPhoneCode.includes('(') ? cPhoneCode.split(/[()]/)[1] : cPhoneCode;
            p.ContactNo = cphoneNumber;
            let usaFormDetail = {};
            if (this.flight['Attr']['is_usa']) {
                Object.assign(usaFormDetail, {
                    City: this.contactForm.get('usaDetailsForm.city').value,
                    State: this.contactForm.get('usaDetailsForm.state').value,
                    CountryName: this.contactForm.get('usaDetailsForm.country_name').value,
                    CountryCode: 'USA',
                    AddressLine1: this.contactForm.get('usaDetailsForm.address').value,
                    AddressLine2: '.',
                    PinCode: this.contactForm.get('usaDetailsForm.postal_code').value,
                    Gender: this.contactForm.get('usaDetailsForm.Gender').value,
                    LocationType: this.contactForm.get('usaDetailsForm.types').value
                });

            }
            p.CountryCode = p.Nationality;
            return { ...p, DateOfBirth, PassportExpiryDate, ...usaFormDetail };
        });
        this.flightService.loading.next(true);
        if (this.flightService.isDevelopment) {
        } else {
            //   RDD
            //   if (baggageProtection) {
            //       this.subs.sink = this.apiHandlerService.apiHandler('servicePurchase', 'post', {}, {}, {
            //           app_reference: this.flightService.appReference,
            //           booking_source: this.flight.booking_source
            //       }).subscribe(resp => {
            //           if (resp.statusCode == 200 || resp.statusCode == 201) {
            //               // console.log('baggage protected successfully', resp.Message || resp.data)
            //           }
            //       });
            //   }
            //   const created_by_id = this.utility.readStorage('b2cUser', sessionStorage)['id'];
            //   let data = {
            //       UserId: created_by_id,
            //       AppReference: this.flightService.appReference,
            //       BookingSource: this.flight.booking_source,
            //       // AppReference: this.flightService.resultToken,
            //       SequenceNumber: 0,
            //       ResultToken: this.flightService.resultToken,
            //       Passengers: passengersTemp
            //   }
            //   console.log(passengersTemp);

            //   this.subs.sink = this.apiHandlerService.apiHandler('commitBooking', 'POST', '', '', {
            //       UserId: created_by_id,
            //       AppReference: this.flightService.appReference,
            //       booking_source: this.flight.booking_source,
            //       BookingSource: "B2C",
            //       // AppReference: this.flightService.resultToken,
            //       SequenceNumber: 0,
            //       ResultToken: this.flightService.resultToken,
            //       Passengers: passengersTemp
            //   }).subscribe(res => {
            //       if (res.Status) {


            //           const BookingDetails = res.data.CommitBooking.BookingDetails;
            //           this.flightService.CommitBookingResponse.next(BookingDetails);
            //           this.router.navigate(['/flight/confirm-passenger']);
            //       } else {
            //           this.swalService.alert.oops(res.Message);
            //           setTimeout(() => {
            //               this.router.navigate(['/flight/result']);
            //           }, 100);
            //       }
            //       this.flightService.loading.next(false);
            //   });

            // RDD ends copy to next page
            this.subs.sink = this.apiHandlerService.apiHandler('createAppReference', 'POST', '', '', {
                module: "flight"
            }).subscribe(res => {
                if ((res.statusCode == 200 || res.statusCode == 201) && res.data) {
                    this.appRef = res.data;

                    const created_by_id = this.utility.readStorage('b2cUser', sessionStorage)['id'];
                    let commitBookingBody = {
                        UserId: created_by_id ? created_by_id : 0,
                        UserType: 'B2C',
                        AppReference: this.appRef,
                        booking_source: this.flight.booking_source,
                        BookingSource: "B2C",
                        SequenceNumber: 0,
                        ResultToken: this.flightService.resultToken,
                        Passengers: passengersTemp,
                        Remark:"nosafer B2C",
                        PromoCode: this.selectedPromocode,    
                    }
                    this.flightService.passengerDetails.next([commitBookingBody, this.contactForm.value]);
                    localStorage.setItem('passengerDetails', JSON.stringify([commitBookingBody, this.contactForm.value]));
                    this.subs.sink = this.apiHandlerService.apiHandler('commitBooking', 'POST', '', '', commitBookingBody).subscribe(res => {
                        if (res.Status) {
                            const BookingDetails = res.data.CommitBooking.BookingDetails;
                            let details: any;
                            details = BookingDetails;
                            details.FlightDetails = details.JourneyList;
                            this.flightService.CommitBookingResponse.next(details);
                            localStorage.setItem('flightCommitBookingResponse', JSON.stringify(details));
                            this.router.navigate(['/flight/confirm-passenger']);
                            this.loading=false;  
                        } else {
                            this.swalService.alert.oops(res.Message);
                            setTimeout(() => {
                                this.router.navigate(['/flight/result']);
                            }, 100);
                        }
                        this.flightService.loading.next(false);
                    });
                }
            })
        }
    }

    copyContact() {
        let passengers = <FormArray>this.contactForm.controls["passengers"];
        passengers.controls[0].patchValue({
            Title: this.contactForm.value.contact.Title,
            FirstName: this.contactForm.value.contact.FirstName,
            LastName: this.contactForm.value.contact.LastName,
            MiddleName: this.contactForm.value.contact.MiddleName,
        });
    }

    getBaggageProtection(val) {
        this.flightService.isBaggeProtected.next(val)
    }


    addYearsToDate(y: number, m: number) {
        const d = new Date();
        const year = d.getFullYear();
        const month = d.getMonth();
        const day = d.getDate();
        const c = new Date(year + y, month + m, day);
        return c;
    }

    onContinue() {
        this.router.navigate(['/flight/guest-details']);
    }

 
    getTravellersList() {
        this.subs.sink = this.apiHandlerService.apiHandler('userTravellersList', 'POST')
            .subscribe(res => {
                if (res && res.data.length) {
                    this.travelList = res.data;
                    this.cdRef.detectChanges();
                }
            });
    }

    setAdultDetails(passengerDetails, index, selectedSection) {
        this.setPassengerTitle(passengerDetails, selectedSection);
        this.contactForm.controls['passengers']['controls'][index].patchValue({
            Title: this.selectedTitle,
            FirstName: passengerDetails.first_name.toUpperCase(),
            MiddleName: passengerDetails.middle_name.toUpperCase(),
            LastName: passengerDetails.last_name.toUpperCase(),
            Gender: passengerDetails.gender,
            PassportNumber: passengerDetails.passport_no,
            PassportIssuingCountry: passengerDetails.issuing_country,
            DateOfBirth: new Date(formatDate(new Date(passengerDetails.date_of_birth), 'yyyy-MM-dd', 'en-US')),
            PassportExpiry: new Date(formatDate(new Date(passengerDetails.passport_expiry), 'yyyy-MM-dd', 'en-US')),
            AddressLine1: passengerDetails.address,            //verify 
            AddressLine2: passengerDetails.address1,
            Email: passengerDetails.email,
            PinCode: passengerDetails.postal_code,
            City: passengerDetails.city,
            Nationality: passengerDetails.country,
        });
    }

    setPassengerTitle(passengerDetails, selectedSection) {
        let titleArray;
        if (selectedSection === 'adults') {
            titleArray = this.titles.filter(element => (element.paxType === "ADULT" && element.titleName === passengerDetails.title));
        }
        else {
            titleArray = this.titles.filter(element => (element.paxType === "CHILD" && element.titleName === passengerDetails.title));
        }
        if (titleArray.length == 0) {
            this.selectedTitle= "";
        }else
        {
            this.selectedTitle=passengerDetails.title;
        }
    }

    clearDetails(index) {
        this.contactForm.controls['passengers']['controls'][index].patchValue({
            Title: '',
            FirstName: '',
            MiddleName: '',
            LastName: '',
            Gender: '',
            PassportNumber: '',
            PassportIssuingCountry: 'USA',
            DateOfBirth: '',
            PassportExpiryDate: '',
            AddressLine1: '',
            AddressLine2: '',
            Email: '',
            PinCode: '',
            City: '',
            Nationality: 'USA',
            PassengerSelection:''// Used for passenger selection
        });
    }

    alphaNumberOnly (e) {  // Accept only alpha numerics, not special characters 
        var regex = new RegExp("^[a-zA-Z0-9]+$");
        var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (regex.test(str)) {
            return true;
        }
    
        e.preventDefault();
        return false;
      }

      openStaticPage(page_title) {
        const url = this.router.serializeUrl(
            this.router.createUrlTree(['cms/'+page_title])
        );
        window.open('#' + url, '_blank');
    }

    setDateOfBirth(bookingFlightData: any, key: string, i: number): Date | string {
        if (bookingFlightData && bookingFlightData.hasOwnProperty('SearchData') && bookingFlightData.SearchData[key][i] != null) {
            return new Date(formatDate(new Date(bookingFlightData.SearchData[key][i]), 'yyyy-MM-dd', 'en-US'));
        } else {
            return '';
        }
    }

    setChildDateOfBirth(bookingFlightData: any, i: number): Date | string {
        return this.setDateOfBirth(bookingFlightData, 'childDOB', i);
    }

    setInfantDateOfBirth(bookingFlightData: any, i: number): Date | string {
        return this.setDateOfBirth(bookingFlightData, 'infantDOB', i);
    }

    getSeatLayout(res) {
        this.isSeatLoading=true;
        let request={
            ResultToken:res.ResultToken,
            booking_source:res.booking_source
        }
        this.apiHandlerService.apiHandler('flightSeatAvailability', 'POST', '', '',request).subscribe(response => {
            if ((response.statusCode == 200 || response.statusCode == 201) && response.data) {
                this.seatMapData=response.data.seat_map;
                this.setSeatMapSectors(this.seatMapData);
                this.setSelectedPassenger(0);
                this.isSeatLoading=false;
                this.cdRef.detectChanges();
            }
            else{
                this.isSeatLoading=false;
                this.cdRef.detectChanges();
            }
        }, (error) => {
            this.isSeatLoading=false;
            this.cdRef.detectChanges();
        }
        );
    }

    setSeatMapSectors(seatMapData){
        const map = new Map<any, any>();
        for (let item of Object.keys(seatMapData)) {
            map.set(item, []);
        }
        this.seatMapSectors=map;
    }

    setSelectedPassenger(ii) {
        const filteredArray = this.passengers.controls.filter((passenger) => {
          const control = passenger as FormGroup;
          return control.controls.travellerType.value !== 'infants';
        });
      
        if (filteredArray[ii]) {
          this.selectedPassengerIndex = ii;
          this.selectedPassenger = filteredArray[ii];
        } else {
          this.setSelectedTab(this.selectedTabIndex + 1);
        }
    }

    moveToNextOption(currentOption: ElementRef, nextIndex: number) {
        if (nextIndex < 0 || nextIndex >= this.passengers.value.length) {
            const isAllSeatsSelected = this.keysArray.filter(value => value.sectorIndex === this.selectedTabIndex).length === this.passengers.value.length;
            if (isAllSeatsSelected && nextIndex >= this.passengers.value.length) {
                this.setSelectedTab(this.selectedTabIndex + 1);
            }
            this.setSelectedPassenger(0);
            nextIndex = 0;
        }
        const nextOption = currentOption.nativeElement.parentElement.parentElement.querySelectorAll('input')[nextIndex];
        this.renderer.setProperty(nextOption, 'checked', true);
        nextOption.focus();
    }

    removeSeat(item: any, sectorIndexToRemove: any, seat: any, selectedPassengerToRemove: any, passenger: any) {
        const passengerData = passenger.controls.SelectedSeats.value;
        const index = passengerData.findIndex((item) => item.sectorIndex === sectorIndexToRemove && item.selectedPassenger === selectedPassengerToRemove);
        if (index !== -1) {
            passengerData.splice(index, 1);
            passenger.patchValue({ SelectedSeats: passengerData });
        }
        const sector = this.seatMapSectors.get(item.key) || [];
        const sectorIndex = sector.indexOf(seat.SeatCode);
        if (sectorIndex !== -1) {
            sector.splice(sectorIndex, 1);
            seat.isSelected = false;
            this.cdRef.detectChanges();
        }
        this.seatMapSectors.set(item.key, sector);
        this.setSelectedPassenger(selectedPassengerToRemove);
        this.moveToNextOption(this.optionRef, this.selectedPassengerIndex);
    }

    setSelectedTab(id){
        this.selectedTabIndex = id;
        this.setSelectedPassenger(0);
        this.cdRef.detectChanges();
        for (const passenger of this.passengers.controls) {
            passenger.patchValue({
                SelectedSelectorId: this.selectedTabIndex
            });
        }
    }

    onCheckboxChange(item: any, selectedSectorIndex: any, selectedSeat: any, event: any) {
        if (!this.selectedPassenger || (this.selectedPassenger.controls.SelectedSeats.value || []).some(s => s.sectorIndex === selectedSectorIndex && s.selectedPassenger === this.selectedPassengerIndex) || (selectedSeat.value.hasOwnProperty('isSelected') && selectedSeat.value.isSelected)) {
            return;
          }
          const seatCode = selectedSeat.value.SeatCode;
          const sector = this.seatMapSectors.get(item.key) || [];
          selectedSeat.value.isSelected = true;
          selectedSeat.value.sectorIndex = selectedSectorIndex;
          selectedSeat.value.selectedPassenger = this.selectedPassengerIndex;
          this.keysArray.push(selectedSeat.value);
          this.selectedPassenger.patchValue({
            SelectedSeats: this.keysArray,
            SelectedSelectorId: selectedSectorIndex
          });
          sector.push(seatCode);
          this.cdRef.detectChanges();
          this.setSelectedPassenger(this.selectedPassengerIndex + 1);
          this.moveToNextOption(this.optionRef, this.selectedPassengerIndex);
          this.seatMapSectors.set(item.key, sector);
    }

    onTabSelected(event: NgbNavChangeEvent): void {
        let id = +event.nextId;
        this.setSelectedTab(id);
    }

    isSeatSelected(sectorIndex: number, selectedPassenger: number, passenger: any): boolean {
        if (passenger && passenger.controls.SelectedSeats.value != null) {
            return passenger.controls.SelectedSeats.value.some(s => s.sectorIndex === sectorIndex && s.selectedPassenger === selectedPassenger);
        }
    }

    setSeatId(passengers: any[]) {
        passengers.forEach((passenger, i) => {
            passenger.SeatId=[];
            if(this.seatMapSectors){
                // Add null values to passenger.SeatId based on this.seatMapSectors.size
            for (let j = 0; j < this.seatMapSectors.size; j++) {
                passenger.SeatId.push(null);
            }
            if (passenger.SelectedSeats && passenger.SelectedSeats.length > 0) {
                const result = passenger.SelectedSeats.filter((seat) => seat.selectedPassenger === i);
                result.forEach((seat) => {
                    passenger.SeatId[seat.sectorIndex] = seat.ResultToken;
                });
            }
            }
        });
    }

    setNull(passengers) {
        // Assuming passengers is the array containing the passenger objects
        // Check if all passengers' SeatId is null
        const allSeatIdsNull = passengers.every(passenger => {
            return passenger.SeatId.every(seatId => seatId === null);
        });
        // If all SeatId values are null, set them to an empty array
        if (allSeatIdsNull) {
            passengers.forEach(passenger => {
                passenger.SeatId = [];
            });
        }
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }


    setPromoCode(promocode) {
        this.selectedPromocode = promocode.promo_code;
        this.flightService.flightPromocode.next({
            promocode: promocode
        });
        localStorage.setItem('flightPromocode', JSON.stringify(promocode));
    }

    setSelectedPromo(promocode, index) {
        this.promocodeList.forEach((code, i) => {
            code.selected = (i === index); // Set selected to true only for the clicked index
        });
        this.txtCouponCodeValue = `${promocode.promo_code}`;
        this.isInvalidPromo = false;
        this.disableApplyPromo = true;
        this.cdRef.detectChanges();
        this.setPromoCode(promocode);
    }

    removePromoCode() {
        this.flightService.flightPromocode.next({
            promocode: ''
        });
        this.txtCouponCodeValue = "";
        localStorage.setItem('flightPromocode', JSON.stringify(''));
    }


    getPromoCodeList() {
        this.subs.sink = this.apiHandlerService.apiHandler('listPromocode','POST', '', '', { Currency: this.appGlobal.selectedCurrency.value })
            .subscribe(res => {
                if (res) {
                    this.promocodeList = res.data.filter(element => element.category == 'Flight');
                    this.cdRef.detectChanges();
                }
            });
    }

    removeSelectedPromo() {
        // Assuming this.promocodeList is an array of objects with a 'selected' property
        for (let i = 0; i < this.promocodeList.length; i++) {
            this.promocodeList[i].selected = false;
        }
        // Reset the radio button selection
        const radioButtons = document.getElementsByName("cpnRadio");
        for (let i = 0; i < radioButtons.length; i++) {
            const radioButton = radioButtons[i] as HTMLInputElement;
            radioButton.checked = false;
        }
        this.selectedPromocode = "";
        this.txtCouponCodeValue= "";
        this.disableApplyPromo = false;
        this.cdRef.detectChanges();
        this.flightService.flightPromocode.next({
            promocode: ''
        });
        localStorage.setItem('flightPromocode', JSON.stringify(''));
    }

    applyCoupon() {
        if (!this.txtCouponCodeValue) {
          return;
        }
        this.flightService.loading.next(true);
        let coupon = this.txtCouponCodeValue;
        // this.removeSelectedPromo();
        let request = {
          promocode: this.txtCouponCodeValue,
        };
        
        this.apiHandlerService.apiHandler('getPromoCodeInfo', 'POST', '', '', request).subscribe(response => {
          if ((response.statusCode == 200 || response.statusCode == 201) && response.data && response.data[0]) {
            this.disableApplyPromo = true;
            this.isInvalidPromo = false;
            this.flightService.loading.next(false);
            this.cdRef.detectChanges();
            this.setPromoCode(response.data[0]);
          } else {
            this.handleInvalidPromoCode();
          }
        }, (error) => {
          this.handleInvalidPromoCode();
        });
      }
    
      handleInvalidPromoCode() {
        this.disableApplyPromo = false;
        this.txtCouponCodeValue = '';
        this.isInvalidPromo = true;
        this.flightService.loading.next(false);
        this.cdRef.detectChanges();
      }

}
